import { render, staticRenderFns } from "./ClaimTypesField.vue?vue&type=template&id=11f7ee6d"
import script from "./ClaimTypesField.vue?vue&type=script&lang=js"
export * from "./ClaimTypesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports